export interface Schema {
  defaultCollection?: boolean;
}
